import { ApiService } from './../../../services/api.service';
import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';

@Component({
  selector: 'app-business-security-settings',
  standalone: true,
  imports: [CommonModule, CommonSkeletonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './business-security-settings.component.html',
  styleUrls: ['./business-security-settings.component.scss']
})
export class BusinessSecuritySettingsComponent implements OnInit {
  @Input() commonemit
  values: any;
  loadAPIcall:boolean=false;
  MemberShipType:string;
  constructor(private api: ApiService) { }

  ngOnInit() {
    var businessId = localStorage.getItem('businessId')
    this.MemberShipType = localStorage.getItem('MemberShipType')
    this.loadAPIcall=true
        this.api.query('business/businessSecurityDetails/' + businessId).subscribe(res=>{
          this.loadAPIcall=false
          this.values = res.data.businessSecurityDetails

        })
      }

}
